import React, { useState } from 'react';
import { ChevronRight, Star, Zap, Lock, X } from 'lucide-react';
import Mascot from '../components/Mascot';
const generateRoadPath = (count) => {
  const height = count * 160;
  const cx = 200; // centro X del SVG (ancho 400)
  const amplitude = 100; // qué tanto se curva

  let path = `M ${cx} 0`;

  for (let i = 0; i < count; i++) {
    const y1 = (i * height / count) + (height / count / 2);
    const y2 = ((i + 1) * height / count);
    const xOffset = i % 2 === 0 ? cx + amplitude : cx - amplitude;

    path += ` C ${xOffset} ${y1}, ${xOffset} ${y1}, ${cx} ${y2}`;
  }

  return path;
};


export default function ModulesView({ ACADEMY_DATA, userProgress, setSelectedModule, setView, onUnlockModule }) {
  // --- ESTADOS PARA MODALES ---
  const [showSkipConfirm, setShowSkipConfirm] = useState(null); // ID del módulo a desbloquear

  // Reemplaza el modal rojo por uno bonito
  const [xpErrorModal, setXpErrorModal] = useState(null); // { title, message, missingXp }

  const currentSkin = userProgress?.currentSkin || 'bribark';

  const dollyXpMsgs = [
    "Ups… te faltan un poquito de XP 💕",
    "Aún no alcanza, pero ya casi ✨",
    "Un poco más de práctica y será tuyo 💖",
    "Todavía no, pero vas muy bien 🌸",
    "Sigamos jugando para ganar más XP 😊"
  ];

  const bribarkXpMsgs = [
    "Eh… te faltan XP 😏",
    "Casi, pero no… a seguir dandole! 🐾",
    "Ese objeto pide más XP, campeón 💪",
    "No alcanza… toca regresar a la \"chambing\" un poco 😈",
    "Más XP primero, luego hablamos 😎"
  ];

  const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

  // Mensaje aleatorio header
  // --- DENTRO DE ModulesView ---

// 1. Definimos las listas de mensajes (pueden estar aquí o fuera)
const dollyMsgs = [
  "Hoy es un buen día para aprender algo nuevo 💖",
  "Vamos paso a paso… este módulo es tuyo ✨",
  "Concéntrate y disfruta: cada set suma.",
  "Aquí empieza un nuevo avance. Tú puedes 🌸",
  "Aprender también puede sentirse ligero y bonito."
];

const briMsgs = [
  "Alright, game on. Vamos a dominar este módulo 🔥",
  "Nuevo módulo, nuevo reto. Let’s go 😎",
  "Hoy venimos a subir nivel, no a calentar.",
  "Focus mode ON. Este módulo no se va a completar solo.",
  "Ready? Porque hoy nos volvemos bilingües 💥"
];

// 2. Usamos useState para "congelar" un mensaje diferente en cada visita
const [headerMessage] = useState(() => {
  const activeSkin = userProgress?.currentSkin || 'bribark';
  const skin = activeSkin || userProgress?.currentSkin || 'bribark';
  const selectedList = skin.includes('dolly') ? dollyMsgs : briMsgs;
  return selectedList[Math.floor(Math.random() * selectedList.length)];
});
  const getChallengeMessage = () => {
    const msgs = [
      "¡Hoy vamos por el doble de puntos!",
      "¿Listo para romper tu récord?",
      "¡El objetivo de hoy es aprender más!",
      "¡Vamos a desbloquear sets misteriosos!"
    ];
    return msgs[Math.floor(Math.random() * msgs.length)];
  };

  // Helper: obtener el módulo por id (para conocer costos/requisitos en el modal)
  const getModuleById = (moduleId) => {
    const all = Object.values(ACADEMY_DATA || {});
    return all.find(m => m && m.id === moduleId);
  };

  const selectedLockedModule = showSkipConfirm ? getModuleById(showSkipConfirm) : null;
  const unlockCost = selectedLockedModule?.unlockCost ?? 200;
  const requiredXP = selectedLockedModule?.requiredXP ?? null;
  // ← Aquí termina tu último useState o código previo

  
  return (
    <div className="space-y-6 pb-20">
      {/* --- HERO HEADER --- */}
      <div className="bg-gradient-to-br from-indigo-600 to-purple-700 rounded-[2.5rem] p-6 text-white shadow-2xl shadow-indigo-200 relative overflow-hidden animate-in slide-in-from-top-10 duration-700">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <img
          src="/others/logoeducat.png"
          alt="School Logo"
          className="absolute top-4 right-4 w-16 h-16 opacity-30 object-contain grayscale mix-blend-overlay"
        />

        <div className="relative z-10 flex items-center gap-4 pt-4">
          <div className="shrink-0 -ml-2 filter drop-shadow-lg">
            <Mascot
              type={currentSkin}
              message={headerMessage}
            />
          </div>

          <div className="flex-1 space-y-1">
            <div className="inline-flex items-center gap-1 bg-white/20 backdrop-blur-md px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-white/30">
              <Star size={10} fill="currentColor" className="text-yellow-300" />
              Estudiante Pro
            </div>
            <h2 className="text-2xl font-black leading-tight">
              ¡Hola de nuevo!
            </h2>
            <div className="flex items-center gap-2 text-indigo-200 text-xs font-bold">
              <Zap size={14} className="text-amber-400 fill-amber-400" />
              <span>{userProgress.xp} XP Totales</span>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-black/20 rounded-full h-2 w-full overflow-hidden">
          <div
            className="h-full bg-amber-400 rounded-full"
            style={{ width: `${Math.min((userProgress.completedSets?.length || 0) * 2, 100)}%` }}
          ></div>
        </div>
        <div className="flex justify-between mt-2 text-[10px] font-bold text-indigo-200 uppercase tracking-widest">
          <span>Nivel Inicial</span>
          <span>{userProgress.completedSets?.length || 0} Sets</span>
        </div>
      </div>

{/* --- MAPA DE MÓDULOS (ZIGZAG) --- */}
<div className="relative px-2">
  <h3 className="font-black text-slate-400 text-xs uppercase tracking-widest pl-4 mb-6 animate-in fade-in delay-300">
    Tu Mapa de Aprendizaje
  </h3>

  {/* Línea central del camino */}
 
<div className="relative flex flex-col gap-2">
    {/* === CARRETERA SVG === */}
<svg
  className="absolute inset-0 w-full pointer-events-none z-0"
  style={{ height: `${Object.values(ACADEMY_DATA).length * 160}px` }}
  viewBox={`0 0 400 ${Object.values(ACADEMY_DATA).length * 160}`}
  preserveAspectRatio="none"
>
  <defs>
    {/* Textura de carretera */}
    <pattern id="roadDash" patternUnits="userSpaceOnUse" width="20" height="20">
      <line x1="10" y1="0" x2="10" y2="20" stroke="white" strokeWidth="2" strokeDasharray="8,8" opacity="0.6"/>
    </pattern>
  </defs>

  {/* Sombra de la carretera */}
  <path
    d={generateRoadPath(Object.values(ACADEMY_DATA).length)}
    fill="none"
    stroke="#c7d2fe"
    strokeWidth="32"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  {/* Carretera base gris */}
  <path
    d={generateRoadPath(Object.values(ACADEMY_DATA).length)}
    fill="none"
    stroke="#6366f1"
    strokeWidth="26"
    strokeLinecap="round"
    strokeLinejoin="round"
    opacity="0.25"
  />
  {/* Línea central punteada blanca */}
  <path
    d={generateRoadPath(Object.values(ACADEMY_DATA).length)}
    fill="none"
    stroke="white"
    strokeWidth="3"
    strokeLinecap="round"
    strokeDasharray="12,16"
    opacity="0.7"
  />
</svg>
    {Object.values(ACADEMY_DATA).map((mod, index) => {
      if (!mod || !mod.id) return null;

      // ✅ LÓGICA ORIGINAL — sin cambios
      const isLocked = mod.requiredXP && userProgress.xp < mod.requiredXP;
      const localUnlockCost = mod.unlockCost ?? 200;

      // Visual extras
      const isLeft = index % 2 === 0;
      const moduleEmojis = ['💬','🏘️','👗','🪪','⏳','✈️','🧠','💼','🍽️','🎓'];
      const emoji = mod.emoji || moduleEmojis[index % moduleEmojis.length];

      const completedInModule = (userProgress.completedSets || [])
        .filter(id => typeof id === 'string' && id.startsWith(mod.id)).length;
      const totalSets = mod.units?.reduce((acc, u) => acc + (u.sets?.length || 0), 0) || 1;
      const progressRatio = Math.min(completedInModule / totalSets, 1);
      const stars = progressRatio >= 0.9 ? 3 : progressRatio >= 0.4 ? 2 : progressRatio > 0 ? 1 : 0;
      // Genera un path SVG serpenteante

      return (
        <div
          key={mod.id}
          className={`flex items-center gap-3 animate-in fade-in slide-in-from-bottom-4 fill-mode-backwards
            ${isLeft ? 'flex-row' : 'flex-row-reverse'}
          `}
          style={{ animationDelay: `${index * 80}ms` }}
        >
          {/* === TARJETA === */}
          <button
            onClick={() => {
              if (isLocked) {
                // ✅ LÓGICA ORIGINAL
                setShowSkipConfirm(mod.id);
              } else {
                // ✅ LÓGICA ORIGINAL
                console.log('📦 Módulo seleccionado:', mod);
                console.log('📚 ¿Tiene units?', mod.units);
                console.log('🔑 Keys del módulo:', Object.keys(mod));
                setSelectedModule(mod);
                setView('units');
              }
            }}
            className={`flex-1 group p-4 rounded-[2rem] border-2 shadow-md transition-all text-left
              ${isLocked
                ? 'bg-slate-100 border-slate-200 opacity-70'
                : 'bg-white border-slate-100 hover:border-indigo-400 hover:shadow-xl hover:-translate-y-1'
              }
            `}
          >
            <div className="flex items-center gap-3">
              {/* Icono circular */}
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl shrink-0 relative overflow-hidden
                ${isLocked
                  ? 'bg-slate-200'
                  : 'bg-gradient-to-br from-indigo-100 to-purple-100 group-hover:from-indigo-500 group-hover:to-purple-600'
                }
              `}>
                {isLocked ? <Lock size={22} className="text-slate-400" /> : <span>{emoji}</span>}
                <div className={`absolute -top-1 -right-1 w-5 h-5 rounded-full text-[9px] font-black flex items-center justify-center
                  ${isLocked ? 'bg-slate-300 text-slate-500' : 'bg-indigo-600 text-white'}
                `}>
                  {index + 1}
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <p className={`font-black text-sm leading-tight
                  ${isLocked ? 'text-slate-400' : 'text-slate-800 group-hover:text-indigo-700'}
                `}>
                  {mod.name}
                </p>

                {/* Estrellas */}
                {!isLocked && (
                  <div className="flex gap-0.5 mt-1">
                    {[1,2,3].map(s => (
                      <span key={s} className={`text-xs ${s <= stars ? 'text-amber-400' : 'text-slate-200'}`}>★</span>
                    ))}
                  </div>
                )}

                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  {isLocked ? (
                    <>
                      <span className="text-[10px] font-black text-amber-500 flex items-center gap-0.5">
                        <Zap size={9} fill="currentColor" /> Requiere {mod.requiredXP} XP
                      </span>
                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                        Salto: {localUnlockCost} XP
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-[10px] font-bold text-slate-400">
                        {mod.units?.length || 0} unidades
                      </span>
                      <span className="text-slate-200">•</span>
                      <span className="text-[10px] font-bold text-indigo-400">
                        +{(mod.units?.length || 1) * 50} XP
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Barra de progreso */}
            {!isLocked && progressRatio > 0 && (
              <div className="mt-3 w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-indigo-400 to-purple-500 rounded-full transition-all duration-700"
                  style={{ width: `${progressRatio * 100}%` }}
                />
              </div>
            )}
          </button>

          {/* === NODO CENTRAL === */}
          <div className={`w-10 h-10 rounded-full border-4 flex items-center justify-center shrink-0 shadow-md z-10
            ${isLocked
              ? 'bg-slate-100 border-slate-200'
              : stars === 3
                ? 'bg-amber-400 border-amber-300'
                : progressRatio > 0
                  ? 'bg-indigo-500 border-indigo-300'
                  : 'bg-white border-indigo-200'
            }
          `}>
            {isLocked
              ? <Lock size={14} className="text-slate-400" />
              : stars === 3
                ? <span className="text-sm">⭐</span>
                : progressRatio > 0
                  ? <span className="text-white text-xs font-black">✓</span>
                  : <span className="text-indigo-300 text-xs font-black">{index + 1}</span>
            }
          </div>

          {/* Espacio espejo para alinear zigzag */}
          <div className="flex-1 opacity-0 pointer-events-none" />
        </div>
      );
    })}
  </div>
</div>


      {/* === MODAL CONFIRMACIÓN SALTAR === */}
      {showSkipConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in">
          <div className="bg-white rounded-[2rem] p-6 w-full max-w-sm text-center shadow-2xl border-4 border-indigo-100 relative mt-10">
            {/* Mascota asomándose */}
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-32 h-32">
              <Mascot type={currentSkin} />
            </div>

            <div className="mt-12">
              <h3 className="text-xl font-black text-slate-700 mb-2">¿Desbloquear Módulo?</h3>

              <p className="text-slate-400 text-xs mb-4 px-4">
                Aún no cumples los requisitos de XP, pero puedes usar tus puntos para saltar.
              </p>

              {requiredXP != null && (
                <div className="bg-slate-50 p-3 rounded-xl border border-slate-200 mb-4">
                  <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                    Requisito
                  </p>
                  <p className="text-xs font-bold text-slate-600 mt-1">
                    Requiere {requiredXP} XP para entrar normal
                  </p>
                </div>
              )}

              <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 mb-4">
                <p className="text-xs font-bold text-amber-600 uppercase mb-1">Costo de Salto</p>
                <p className="text-2xl font-black text-amber-500 flex justify-center gap-1 items-center">
                  <Zap fill="currentColor" /> {unlockCost} XP
                </p>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={() => setShowSkipConfirm(null)}
                  className="py-3 rounded-xl font-bold text-slate-500 bg-slate-100 hover:bg-slate-200 transition-colors"
                >
                  CANCELAR
                </button>

                <button
                  onClick={() => {
                    if (userProgress.xp >= unlockCost) {
                      if (typeof onUnlockModule === 'function') onUnlockModule(showSkipConfirm, unlockCost);
                      setShowSkipConfirm(null);
                    } else {
                      const missingXp = Math.max(unlockCost - (userProgress.xp || 0), 0);
                      const msg = currentSkin.includes('dolly')
                        ? pickRandom(dollyXpMsgs)
                        : pickRandom(bribarkXpMsgs);

                      setShowSkipConfirm(null);
                      setXpErrorModal({
                        title: "¡Te faltan XP!",
                        message: msg,
                        missingXp
                      });
                    }
                  }}
                  className="py-3 rounded-xl font-bold text-white bg-indigo-600 hover:bg-indigo-500 shadow-lg shadow-indigo-200 transition-colors"
                >
                  CONFIRMAR
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* === MODAL XP INSUFICIENTE (BONITO, CON MASCOT) === */}
      {xpErrorModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in">
          <div className="bg-white rounded-[2.5rem] p-6 w-full max-w-sm text-center shadow-2xl animate-in zoom-in-95 duration-200 border-4 border-indigo-100 relative mt-10">
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-32 h-32 pointer-events-none">
              <Mascot type={currentSkin} />
            </div>

            <div className="mt-12 space-y-4">
              <h3 className="text-2xl font-black text-slate-700 leading-tight">
                {xpErrorModal.title}
              </h3>

              <div className="bg-slate-50 rounded-2xl p-4 border border-slate-200">
                <p className="text-sm font-black text-slate-700">
                  {xpErrorModal.message}
                </p>
                <p className="text-xs font-bold text-slate-400 mt-2 uppercase tracking-widest">
                  Te faltan {xpErrorModal.missingXp} XP
                </p>
              </div>

              <div className="grid grid-cols-1 gap-3 pt-2">
                <button
                  onClick={() => setXpErrorModal(null)}
                  className="py-3 rounded-2xl font-black text-white bg-slate-800 hover:bg-slate-700 transition-colors border-b-4 border-slate-900 active:border-b-0 active:translate-y-1"
                >
                  ENTENDIDO
                </button>
              </div>
            </div>

            <button
              onClick={() => setXpErrorModal(null)}
              className="absolute top-4 right-4 p-2 bg-slate-100 rounded-full text-slate-400 hover:text-slate-600"
              aria-label="Cerrar"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
